module.exports = __webpack_public_path__ + "img/excel.82d03f19.svg";